import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IngredientsFilters } from '../../../commons/models/ingredient';

@Component({
  selector: 'app-ingredients-filters',
  templateUrl: './ingredients-filters.component.html',
  styleUrls: ['./ingredients-filters.component.scss']
})
export class IngredientsFiltersComponent {
  @Output()
  onFilter: EventEmitter<IngredientsFilters> = new EventEmitter();

  private _defaultFilters: IngredientsFilters;
  filtersForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this._createForm();
  }

  private _createForm() {
    let group = {
      search: "",
    }

    this.filtersForm = this.fb.group(group);
  }

  applyFilters() {
    this.onFilter.emit(this._getPayment());
  }

  private _getPayment(): IngredientsFilters {
    let filters: IngredientsFilters = {}
    if (this.filtersForm) {
      const values = this.filtersForm.value;
      filters.search = values.search;
    }
    return filters;
  }

  resetFilters() {
    this.filtersForm.reset();
    this.filtersForm.patchValue({
      search: "",
    });
    this._setDefaultValues();
    this.applyFilters();
  }

  get defaultFilters(): IngredientsFilters {
    return this._defaultFilters;
  }

  @Input()
  set defaultFilters(defaultFilters: IngredientsFilters) {
    this._defaultFilters = defaultFilters;
    this._setDefaultValues();
  }

  private _setDefaultValues() {
    if (this.defaultFilters) {
      if (this.filtersForm) {
        this.filtersForm.patchValue({
          search: this.defaultFilters.search,
        })
      }
    }
  }
}